import type { ReactNode } from "react";

export interface ItemGroupProps {
  children: ReactNode;
}

export const ItemGroup = ({ children }: ItemGroupProps) => (
  <div className="py-1">{children}</div>
);
